var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgG7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.74 34.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-G7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1261773605376",
    "data-name": 1261773605376
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.37,8.74c-1.71-.43-2.95-.42-4,.91-2.25,3,.6,6.14,1.17,7.94a5.25,5.25,0,0,1-.32,4.56C5.85,24.84,2.57,24.49.88,27.4A6,6,0,0,0,.21,32c.51,1.38,1.94,2.1,3.8,2.72a3.82,3.82,0,0,0,3.74-1.26c1.08-1.1,1.56-3,2.48-4.36,1.72-2.64,4-3.9,5.89-6.36,2.29-3.05,2.75-6.21,1.38-8.64a12.7,12.7,0,0,0-7.13-5.32Z",
    transform: "translate(0 0)",
    fill: "#131e2f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3,0C7.46-.34,6.21,6,9.19,6.45,11.8,6.85,13.19.38,10.3,0Z",
    transform: "translate(0 0)",
    fill: "#131e2f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.31,3.2c-2.09.18-2.73,4.39-.64,4.47.93,0,1.65-1,1.88-2.21C15.71,4.64,15.38,3.11,14.31,3.2Z",
    transform: "translate(0 0)",
    fill: "#131e2f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.26,5.81c-1.69.28-2.17,3.76-.27,3.53C18.59,9.15,19.26,5.48,17.26,5.81Z",
    transform: "translate(0 0)",
    fill: "#131e2f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.32,8.47c-1.58-.05-2.22,2.76-.8,2.81C19.78,11.34,20.82,8.51,19.32,8.47Z",
    transform: "translate(0 0)",
    fill: "#131e2f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,11.09c-1.15.06-1.69,2.46-.3,2.28C20.83,13.22,21.18,11,20,11.09Z",
    transform: "translate(0 0)",
    fill: "#131e2f",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgG7);
export default __webpack_public_path__ + "static/media/G7.7cfd18d68b8431045412ffb840ae6877.svg";
export { ForwardRef as ReactComponent };